'use client';
import Link from 'next/link';
import styled from 'styled-components';

export const StyledNavigationBar = styled.nav`
  background-color: ${props => props.theme.colors.get(props.$bgColor)};
  color: ${props => props.theme.colors.get(props.$fontColor)};
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  padding: ${props =>
    props.showLogo && props.theme.spacing(props.$verticalPadding, 6)};
  position: relative;
  padding-left: ${props => props.theme.spacing(0)};

  @media ${props => props.theme.tablet} {
    padding-left: ${props => props.theme.spacing(4)};
  }
`;

export const SkipToContent = styled.a`
  position: fixed;
  left: 0;
  color: ${props => props.theme.colors.text.primary};
  transform: translateX(-110%);
  transition: transform 0.3s;
  padding: 2px 5px;

  &:focus {
    transform: translateY(0%);
  }
`;

export const OllieLogo = styled.div`
  display: flex;

  @media ${props => props.theme.mobileS} {
    flex: 1;
    justify-content: left;
  }

  @media ${props => props.theme.mobileL} {
    flex: ${props => (props.$hasCenterLinks ? 'none' : 1)};
    justify-content: 'left';
  }
`;

export const LogoImgContainer = styled.div`
  max-height: 56px;
  width: auto;
  height: 56px;
`;

export const LeftAligned = styled.div`
  display: flex;
  justify-content: left;
  @media ${props => props.theme.mobileS} {
    margin-right: ${({ theme }) => theme.spacing(3)};
  }
  @media ${props => props.theme.tablet} {
    margin-right: ${({ theme }) => theme.spacing(0)};
  }
`;

export const CenterAligned = styled.div`
  display: flex;
  justify-content: center;

  @media ${props => props.theme.mobileS} {
    flex: none;
  }

  @media ${props => props.theme.mobileL} {
    flex: ${props => (props.$hasCenterLinks ? 1 : 'none')};
  }
`;

export const RightAligned = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const GetStartedButton = styled.div`
  display: none;
  min-width: 162px;
  @media ${props => props.theme.mobileS} {
    display: block;
    a {
      button {
        min-height: 60px;
      }
    }
  }
`;

export const MobileCtaButton = styled.div`
  display: block;
`;

export const NavigationMenuLink = styled.li`
  display: flex;
  list-style: none;
  height: 44px;
  text-align: center;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  & button {
    margin: 0;
  }
`;

export const DesktopNavigationMenu = styled.menu`
  display: none;
  padding: unset;
  @media ${props => props.theme.tabletL} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${props => props.theme.spacing(7)};
  }
`;

export const MobileNavigationMenu = styled.div`
  display: flex;
  @media ${props => props.theme.tabletL} {
    display: none;
  }
`;

export const MobileCtaButtonContainer = styled.div`
  width: 100%;
  bottom: ${props => props.theme.spacing(10)};
  padding: 0 ${props => props.theme.spacing(3)} 0
    ${props => props.theme.spacing(3)};
`;

export const MobileCtaMemberButtonContainer = styled.div`
  width: 100%;
`;

export const MobileButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${props => props.theme.spacing(props.verticalMargin, 0)};
`;

export const BurgerMenu = styled.button`
  background: none;
  display: flex;
  align-items: center;
  padding: ${props => props.theme.spacing(2)};
  border: 2px solid transparent;
  &:focus,
  &:active {
    border: 2px solid ${props => props.theme.colors.border.dark};
  }
`;

export const SlideOutMenu = styled.menu`
  color: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  letter-spacing: 0.01em;
  padding: ${props => props.theme.spacing(4, 0)};
`;

export const SlideOutMenuTopSection = styled.menu`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 40px;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: ${props => props.theme.spacing(2)};
  margin-bottom: ${props => props.theme.spacing(6)};
`;

export const SlideOutMenuCloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.colors.shadowGrey};
  border-radius: 50%;
  width: 50px;
  padding: ${props => props.theme.spacing(3)};
`;

export const LogoLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${props => props.theme.spacing(2)};
  border: 2px solid transparent;
  &:focus,
  &:active {
    border: 2px solid ${props => props.theme.colors.border.dark};
    border-radius: 16px;
  }
`;

export const StyledStepCounter = styled.div`
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.secondary};
`;
